module.exports = __webpack_public_path__ + "media/communication.90e8c501.mp4";